export const getDefaultSuggestions = (
  i18n: { t: (key: string, obj?: object) => string },
  mention: string
) => {
  return [
    {
      comment: `${i18n.t('feed.card.comments.comment_suggestion.congratulations')} 👏🏼`,
      commentWithMention: `${i18n.t('feed.card.comments.comment_suggestion_with_mention.congratulations', { mention })} 👏🏼`,
      option: 'CONGRATULATIONS'
    },
    {
      comment: i18n.t('feed.card.comments.comment_suggestion.good_work'),
      commentWithMention: i18n.t('feed.card.comments.comment_suggestion_with_mention.good_work', {
        mention
      }),
      option: 'GOOD_WORK'
    },
    {
      comment: i18n.t('feed.card.comments.comment_suggestion.thanks_for_sharing'),
      commentWithMention: i18n.t(
        'feed.card.comments.comment_suggestion_with_mention.thanks_for_sharing',
        { mention }
      ),
      option: 'THANKS_FOR_SHARING'
    }
  ]
}
